import { hasManyItems } from 'Data/format'

export function getView(historical_data, disabled) {
  return hasManyItems(historical_data) && !disabled
}
